import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=15c91f80&scoped=true&lang=pug"
import script from "./ReservationList.vue?vue&type=script&lang=ts"
export * from "./ReservationList.vue?vue&type=script&lang=ts"
import style0 from "./ReservationList.vue?vue&type=style&index=0&id=15c91f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c91f80",
  null
  
)

export default component.exports